
import {Box,Typography} from "@mui/material";
import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { SnackbarContent, Stack } from "@mui/material"; 
import { ThemeContext } from "../Homepage";
import { useContext,useEffect, useState } from "react";
import LK_AlertIcon from "../../images/LK_AlertIcon";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Padding } from "@mui/icons-material";
import { max } from "date-fns";

export default function CustomToast({ toastTitle, toastText, openToast, onClose,type,autoHideDuration,width}) {
    const colortypemap=[["Info","#005C8E"],["Success","#00943d"],["Warning","#ffd000"],["Error","#dc272d"]];
    const [colortype,setColortype]=useState("#005C8E");
    const { theme } = useContext(ThemeContext);
    const [open, setOpen] = useState(openToast);
    const testarr=[1]
    useEffect(()=>{
        if(type){
            let color = colortypemap.filter((val)=>type==val[0])
            setColortype(color[0][1]);
        }
    },[type])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        onClose(0)
        setOpen(false);
      };

      const action = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );

    return(
            <Stack spacing={1} direction={'column-reverse'} sx={{ maxWidth: 900,maxHeight:600,}}        //need to do make this responsive    marginTop:"100px"
            >
                {/* {testarr.map((val,index)=> */}
                    <Snackbar
                        open={openToast}
                        anchorOrigin={{ vertical:'top', horizontal:'center' }}
                        autoHideDuration={autoHideDuration?autoHideDuration:10000}
                        onClose={handleClose}
                    >
                        <SnackbarContent 
                            action={action}
                            sx={{
                                color:colortype=="#ffd000"?"#000000":"#FFFFFF", 
                                backgroundColor:colortype,
                                margin:"4px", 
                                borderRadius:"50px",
                                fontFamily:'Roboto',
                                alignContent:"center",
                                justifyContent:"center",
                                textAlign:'center',
                                width:width?width:'auto',
                                // maxWidth:width?width:"900px",
                                //minWidth?? //no need of width then 
                                height:"90px" ,    ///"90px", ??
                                boxShadow:'0px 10px 15px 0px rgba(0,0,0,0.25)',
                                border:"3px solid #FFFFFF",
                                boxSizing:'border-box',
                                padding:"24px ",
                                marginTop:"100px",
                                // marginTop:`calc(100px + ${(testarr.length - index)*6}px)`  ///max it responsive ///????????
                                }}
                                message={
                                    <Box sx={{display:'flex',flexDirection:"row",width:"100%",height:"100%",boxSizing:'border-box', alignContent:"center",justifyContent:"center",textAlign:'start',alignItems:'center',gap:'8px'}}>
                                        <LK_AlertIcon color={colortype} width={"28px"} height={"28px"}/>
                                        <Box sx={{display:'flex',flexDirection:"column"}}>
                                            <Typography sx={{fontFamily:'Roboto',fontSize:"12px"}}>
                                                {toastTitle}
                                            </Typography>
                                            <Typography sx={{fontFamily:'Roboto',fontSize:"12px"}}>
                                                {toastText}
                                            </Typography>
                                        </Box>
                                    </Box>
                                } 
                        >
                        </SnackbarContent>
                        
                    </Snackbar>
                {/* )} */}
            </Stack> 
    );

}



